import { useCallback } from "react"
import { graphsApi, useLazyGetUnpackedGraphDataQuery } from "@store/services/graphsService"
import { linkParse } from "@components/NodeLink/linkHelpers"
import { TKNode } from "@store/services/converter/types"
import { store } from "@store/store"

export const useGetLinkedNode = () => {
  const [fetchGraphData] = useLazyGetUnpackedGraphDataQuery()

  const getLinkedNode = useCallback(
    async (linkedNodeId: string | undefined): Promise<TKNode | undefined> => {
      if (!linkedNodeId) return

      const link = linkParse(linkedNodeId)
      if (!link) return

      const graphKey = `${link.org}#${link.div}#${link.prod}#${link.family}_${link.version}`

      // Check RTK Query cache first
      const state = store.getState()
      const cachedEntry = graphsApi.endpoints.getUnpackedGraphData.select(graphKey)(state)

      // Use cached data if present, otherwise lazy-fetch
      const graphData = cachedEntry.data ?? (await fetchGraphData(graphKey).unwrap())

      if (!graphData) return

      const nodeEntries = Object.entries(graphData.meta.nodes ?? {})
      const [nodeId] = nodeEntries.find(([, node]) => node.label === link.node) ?? []

      const allNodes = [...(graphData.graph.nodes ?? []), ...(graphData.graph.attributes ?? [])]
      const node = allNodes.find((n) => n.name === nodeId)

      return node
    },
    [fetchGraphData],
  )

  return { getLinkedNode }
}
